// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { checkIsInvalidVote, isAcclaimedContest, } from "@sequentech/ui-core";
var UNSELECTED = -1;
/** The marks of a contest, with its explicit invalid option when it is marked. */
var getSelectedIds = function (contest, entry) {
    var ids = entry.choices
        .filter(function (choice) { return choice.selected > UNSELECTED; })
        .map(function (choice) { return choice.id; });
    var invalidCandidate = contest.candidates.find(checkIsInvalidVote);
    if (entry.is_explicit_invalid && invalidCandidate && !ids.includes(invalidCandidate.id)) {
        ids.push(invalidCandidate.id);
    }
    return ids;
};
/**
 * The ballot without any choice, and what that removes. Acclaimed contests
 * keep their entries. The choices are left as the voting screen writes them
 * when a candidate is unmarked by hand.
 */
export var computeClearChoices = function (contests, current) {
    var changes = [];
    var selection = current.map(function (entry) {
        var contest = contests.find(function (item) { return item.id === entry.contest_id; });
        var flags = __assign(__assign({}, entry), { is_blank_ballot: false, is_decline_to_vote: false });
        if (!contest || isAcclaimedContest(contest)) {
            return flags;
        }
        var removed = getSelectedIds(contest, entry);
        if (removed.length === 0) {
            return flags;
        }
        changes.push({ contestId: contest.id, added: [], removed: removed });
        return __assign(__assign({}, flags), { is_explicit_invalid: false, invalid_errors: [], invalid_alerts: [], choices: entry.choices.map(function (_a) {
                var id = _a.id;
                return ({ id: id, selected: UNSELECTED });
            }) });
    });
    return { selection: selection, changes: changes };
};
export var clearRemovesChoices = function (choices) { return choices.changes.length > 0; };
